import { Separator, Text } from "@nju/ui";
import { Links } from "./Links";

interface INavigation {
  title?: string;
}

export function Navigation({ title }: INavigation) {
  return (
    <>
      {title && (
        <>
          <div data-cy="welcome-message">
            <Text
              size={{ "@onlyMobile": "keyS", "@fromTablet": "keyM" }}
              weight="bold"
            >
              {title}
            </Text>
          </div>
          <Separator size="s" tone="invisible" />
        </>
      )}
      <div className="border-b-1 border-b-geyser mb-4 relative scrollbar-width-none webkit-scrollbar-none ms-overflow-style-none only-mobile:w-[calc(100vw-45px)] only-mobile:overflow-y-hidden only-mobile:whitespace-nowrap only-mobile:h-7 only-mobile:mt-3">
        <Links />
      </div>
    </>
  );
}
